export default {
    en: {
        enterTableNo: "Enter Table No",
        enter: "Enter",
        song: "Song",
        newsong: "New Release",
        artist: "Singer",
        hot: "Hot Song",
        sel: "Playlist",
        rec: "Record",
        fav: "My Song",
        otherLang: "中文",
        table: "Table",
        songall: "All",
        国语: "Chinese",
        粤语: "Cantonese",
        台语: "Hokkien",
        潮语: "Teochew",
        英语: "English",
        马来: "Malay",
        日语: "Japanese",
        韩语: "Korean",
        泰语: "Thailand",
        印度语: "Indian",
        越南语: "Vietnam",
        菲律宾语: "Philippine",
        other: "Other",
        singerall: "All Singers",
        singercnmale: "CN Male",
        singercnfemale: "CN Female",
        singergroup: "Group",
        singereurope: "Europe",
        singermalay: "Malay",
        singerjapan: "Japan",
        singerkorea: "Korea",
        singerthailand: "Thailand",
        singerindia: "India",
        singervietnam: "Vietnam",
        singerphilippine: "Philippine",
        noRoomError: "Please scan QR code",
        addSong: "Add Song",
        recd: "Rec",
        noRec: "No Rec",
        ori: "Analog",
        acc: "Digital",
        roomLockedError: "Table is Locked",
        qrHiddenError: "",
        roomNotExistError: "Table is Invalid",
        roomNotOnlineError: "KOD is Offline",
        codeNotExistError: "Code is Invalid",
        emptyCodeError: "Please Enter Code",
        replay: "Replay",
        stop: "Pause",
        play: "Play",
        discard: "Discard",
        next: "Next",
        add: "Add",
        confirm: "Confirm",
        playpause: "Pause",
        nowPlaying: "Now Playing  ",
        nextPlaying: "Next Table  ",
        loading: "Trying To Connect To KOD, Please Wait...",
        addSongSuccess: "Add song success Downloading",
        yt: "YouTube",
        playing: "Now: ",
        website: "Website",
        games: "Games",
        contest: "Singing Contest",
        code: "Code",
        msg: "Msg",
        interval: "Interval",
        clear: "Clear",
        voldown: "Vol -",
        volup: "Vol +",
        micdown: "Mic -",
        micup: "Mic +",
        echodown: "Echo -",
        echoup: "Echo +",
        nextsong: "Next: ",
        all: "All",
        missing: "Song Request",
        submit: "Submit",
        song: "Song",
        songname:"Song name",
        singername:"Singer name",
        missingSongSuccess: "Feedback success",
        missingSongNameRequired: "Song name required",
        missingSongSingerRequired: "Singer name required",
        quotaMessage: "Change Quota",
        codeMessage: "Enter Code",
        enterTableMessage: "Enter Table",
        msgMessage: "Enter Message",
        intervalMessage: "Set Interval",
        clearMessage: "Clear All Tables",
        keyMessage: "Change Key",
        allMessage: "Manage Table",
        danmu: "Danmu",
        danmuImage: "Emote",
        danmuText: "Text",
        danmuText1: "You sing well",
        danmuText2: "Singing not bad!",
        danmuText3: "Clap your hands!",
        danmuText4: "Encore!",
        danmuText5: "Text",
        danmuText6: "Text",
        danmuText7: "Text",
        micvol: "Mic Vol",
        echo: "Echo",
        key: "Key",
        musicvol: "Music Vol",
        controlsDisabledMsg: "Buttons will enable during your song",
        top: "Top",
        mid: "Mid",
        low: "Low",
        search: "Search",
    },
    cn: {
        search: "搜索",
        enterTableNo: "输入桌号",
        enter: "确定",
        song: "歌曲",
        newsong: "新歌",
        artist: "歌星",
        hot: "热门",
        sel: "已点",
        rec: "已录",
        fav: "收藏",
        otherLang: "English",
        table: "桌号",
        songall: "全部",
        国语: "华语",
        粤语: "粤语",
        台语: "闽南语",
        潮语: "潮汕语",
        英语: "英语",
        马来: "马来语",
        日语: "日语",
        韩语: "韩语",
        泰语: "泰语",
        印度语: "印度语",
        越南语: "越南语",
        菲律宾语: "菲律宾语",
        other: "其他",
        singerall: "全部歌手",
        singercnmale: "中港台男",
        singercnfemale: "中港台女",
        singergroup: "乐队组合",
        singereurope: "欧美歌手",
        singermalay: "马来歌手",
        singerjapan: "日本歌手",
        singerkorea: "韩国歌手",
        singerthailand: "泰国歌手",
        singerindia: "印度歌手",
        singervietnam: "越南歌手",
        singerphilippine: "菲律宾歌手",
        noRoomError: "请扫描二维码",
        addSong: "加歌",
        recd: "录音",
        noRec: "不录音",
        ori: "原唱",
        acc: "伴唱",
        roomLockedError: "桌号已被锁",
        qrHiddenError: "",
        roomNotExistError: "桌号不存在",
        roomNotOnlineError: "点歌机不在线",
        codeNotExistError: "编号不存在",
        emptyCodeError: "请输入编号",
        replay: "重播",
        stop: "暂停",
        play: "播放",
        discard: "取消",
        next: "下首",
        add: "加歌",
        confirm: "确定",
        playpause: "暂停",
        nowPlaying: "正在播放",
        nextPlaying: "下一桌",
        loading: "正在尝试连接点歌机，请稍后...",
        addSongSuccess: "点歌成功 下载中",
        yt: "YouTube",
        playing: "播放: ",
        website: "网站",
        games: "游戏",
        contest: "歌唱比赛",
        code: "编号",
        msg: "信息",
        interval: "时隔",
        clear: "清除",
        voldown: "音量 -",
        volup: "音量 +",
        micdown: "麦音 -",
        micup: "麦音 +",
        echodown: "回音 -",
        echoup: "回音 +",
        nextsong: "下首: ",
        all: "全部",
        missing: "请求歌曲",
        submit: "提交",
        songname:"歌名",
        singername:"歌星",
        missingSongSuccess: "反馈成功",
        missingSongNameRequired: "需要歌曲名",
        missingSongSingerRequired: "需要歌星名",
        quotaMessage: "更改配额",
        codeMessage: "输入编号",
        enterTableMessage: "输入桌号",
        msgMessage: "输入信息",
        intervalMessage: "设置时隔",
        clearMessage: "清除所有桌",
        keyMessage: "更改音调",
        allMessage: "管理桌号",
        danmu:"弹幕",
        danmuImage: "动图",
        danmuText: "语句",
        danmuText1: "你唱的太好了",
        danmuText2: "唱的不错！",
        danmuText3: "大家掌声！",
        danmuText4: "再来一首！",
        danmuText5: "Text",
        danmuText6: "Text",
        danmuText7: "Text",
        micvol: "麦克风音量",
        echo: "回音",
        key: "调音",
        musicvol: "音乐音量",
        controlsDisabledMsg: "按钮将在您的歌曲中启用",
        top: "上",
        mid: "中",
        low: "下",
    },
  };